import { ThemeOptions, createTheme } from "@mui/material/styles";

export const themeOptions: ThemeOptions = {
  palette: {
    mode: "light",
    primary: {
      main: "#46932f",
      light: "#46932f",
      dark: "#46932f",
    },
    secondary: {
      main: "#fedb05",
      contrastText: "#000000",
      light: "#fedb05",
      dark: "#fedb05",
    },
    text: {
      primary: "rgba(0,0,0,0.85)",
      secondary: "rgba(0,0,0,0.75)",
    },
    error: {
      main: "#ff0000",
      light: "#ff0000",
      dark: "#ff0000",
    },
    warning: {
      main: "#ff9800",
      light: "#ff9800",
      dark: "#ff9800",
    },
  },
  components: {
    MuiTabs: {
      styleOverrides: {
        root: {
          ":hover": {},
        },
      },
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          "&::-webkit-scrollbar": {
            width: "2px",
            backgroundColor: "transparent",
            borderRadius: 10,
            //borderLeft: "1px solid #000",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#fedb05",
            borderRadius: 5,
          },
        //  border: "1px solid #000",
          borderRightStyle: "none",
          overflowY: "scroll",
          borderRadius: 10,
        },
      },
    },
    MuiTable: {
      styleOverrides: {
        root: {
          "& tbody tr:nth-of-type(odd)": {
            backgroundColor: "#46932f4F",
          },
          "& tbody tr:nth-of-type(even)": {
            //backgroundColor: "#9DBB99FF",
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: 0,
          textAlign: "center",
          fontSize: 12,
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          "& .MuiTableCell-root": {
            fontWeight: "bold",
            color: "#FFFF",
            // backgroundColor: "#46932f",
            backgroundImage:
              "url(http://localhost:3000/static/media/headerx50.bab76807a67125bfcc84.png)",
            paddingTop: 5,
            paddingBottom: 5,
            borderBottom: "5px solid #fedb05",
          },
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontSize: 12,
        },
      },
    },
    MuiInputAdornment: {
      styleOverrides: {
        root: {
          "& .MuiSvgIcon-root": {
            color: "#46932f",
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          backgroundColor:'#035917',
          ":hover": {
            transform: "scale(1.02)",
            fontWeight: "bolder",
          },
        },
      },
    },
  },
};

export const theme = createTheme(themeOptions);
